import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

export class SiteRedirect extends Component {
  componentDidUpdate = (previousProps) => {
    if (
      this.props.redirectPath &&
      previousProps.redirectPath !== this.props.redirectPath
    ) {
      this.props.history.push(this.props.redirectPath);
    }
  };

  render() {
    return <Fragment></Fragment>;
  }
}

export const mapStateToSiteRedirect = ({ siteRedirectReducer = {} }) => {
  return { redirectPath: siteRedirectReducer.redirectPath };
};

export default withRouter(connect(mapStateToSiteRedirect)(SiteRedirect));
